const LinkIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15.207" height="15.207" viewBox="0 0 15.207 15.207">
            <g id="Group_7930" data-name="Group 7930" transform="translate(-530.5 -1304.297)">
                <path
                    id="Path_3323"
                    data-name="Path 3323"
                    d="M5,0H2a2,2,0,0,0-2,2v9.333a2,2,0,0,0,2,2h9.333a2,2,0,0,0,2-2V9"
                    transform="translate(531 1305.67)"
                    fill="none"
                    stroke="#fbfbfb"
                    strokeLinecap="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_206"
                    data-name="Line 206"
                    y1="6.715"
                    x2="6.715"
                    transform="translate(538.285 1305.004)"
                    fill="none"
                    stroke="#fbfbfb"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_207"
                    data-name="Line 207"
                    y1="0.065"
                    x2="5.191"
                    transform="translate(539.809 1305.004)"
                    fill="none"
                    stroke="#fbfbfb"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
                <line
                    id="Line_208"
                    data-name="Line 208"
                    y1="5.191"
                    x2="0.065"
                    transform="translate(544.934 1305.004)"
                    fill="none"
                    stroke="#fbfbfb"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};

export default LinkIcon;
